export const FETCH_ALLGRADE_REQUEST = 'FETCH_ALLGRADE_REQUEST'
export const FETCH_ALLGRADE_SUCCESS = 'FETCH_ALLGRADE_SUCCESS'
export const FETCH_ALLGRADE_FALIURE = 'FETCH_ALLGRADE_FALIURE'
